import {isFiltered} from "../miscellaneous/functions"
import {bestBoundWithTimeLimit, computeBestBoundWithTimeLimit, is_unsat} from "../miscellaneous/functionsCOP"
import {types} from "../miscellaneous/constants"



function createValuesData(data, benchmarks, filters, solvers) {
    let allValues = []
    for (let b of benchmarks) {
        if (!isFiltered(filters, b))
            continue
        // #types:1 #values:4000 (#2:2000)
        let tmp2 = b.info_domains.split("#").map(e => e.split(":")[1])
        allValues.push(parseInt(tmp2[2].split('(')[0]))
    }
    allValues.sort(function(a, b) {return a - b})
    let values = {}
    let intervals = []
    let pad = allValues.length / 10 - 1
    let first = 0
    while(first + pad < allValues.length) {
        //console.log(first, first + pad)
        intervals.push(allValues[first+pad])
        values[allValues[first] + " - " + allValues[first+pad]] = 0
        first += pad + 1
    }
    intervals.push(allValues[allValues.length - 1])

    //console.log(intervals, values)
}


function createScatterData(data, benchmarks, filters, solvers) {
    const s1 = solvers.solver1.id;
    const s2 = solvers.solver2.id;
    let scatters = {'OPTIMUM': [], 'BEST BOUND': []}

    for (let b of benchmarks) {
        if (!isFiltered(filters, b))
            continue
        let d1 = null
        let d2 = null
        for (let d of data[s1])
            if (d.benchmark_id == b.id) {
                d1 = d
                break
            }
        for (let d of data[s2])
            if (d.benchmark_id == b.id) {
                d2 = d
                break
            }
        if(d1 == null || d2 == null)
            continue

        if ((d1.time != -1 && d1.time < filters.timeLimit && d1.bug === 0) || (d2.time != -1 && d2.time < filters.timeLimit && d2.bug === 0)) {
            scatters['OPTIMUM'].push({
                ...b,
                t1: d1.time == -1 || d1.bug === 1 || d1.time >= filters.timeLimit ? filters.timeLimit : (d1.time == 0 ? 1 : d1.time),
                t2: d2.time == -1 || d2.bug === 1 || d2.time >= filters.timeLimit ? filters.timeLimit : (d2.time == 0 ? 1 : d2.time)
            })
            continue
        }
        if (d1.bounds.length == 0 && d2.bounds.length == 0)
            continue

        const b1 = d1.bug === 1 ? false : bestBoundWithTimeLimit(d1.bounds, filters.timeLimit)
        const b2 = d2.bug === 1 ? false: bestBoundWithTimeLimit(d2.bounds, filters.timeLimit)

        let t1 = filters.timeLimit
        let t2 = filters.timeLimit
        if (b1 == false && b2 != false) {
            t2 = b2.time == 0 ? 1 : b2.time
        }
        if (b1 != false && b2 == false) {
            t1 = b1.time == 0 ? 1 : b1.time
        }
        if (b1 != false && b2 != false) {
            if (b1.bound == b2.bound) {
                t1 = b1.time == 0 ? 1 : b1.time
                t2 = b2.time == 0 ? 1 : b2.time
            } else {
                if (b.type.startsWith("min")) {
                    if (b1.bound < b2.bound)
                        t1 = b1.time == 0 ? 1 : b1.time
                    if (b2.bound < b1.bound)
                        t2 = b2.time == 0 ? 1 : b2.time

                }
                if (b.type.startsWith("max")) {
                    if (b1.bound > b2.bound)
                        t1 = b1.time == 0 ? 1 : b1.time
                    if (b2.bound > b1.bound)
                        t2 = b2.time == 0 ? 1 : b2.time

                }
            }
        }
        scatters['BEST BOUND'].push({...b, t1: t1, t2: t2})

    }
    //console.log(scatters)
    return scatters
}

function createConstraintsData(data, benchmarks, filters, solvers) {
    let tmp = []
    let constraints = []
    const opt1 = solvers.solver1.name + " " + solvers.solver1.version + " #Opt"
    const opt2 = solvers.solver2.name + " " + solvers.solver2.version + " #Opt"
    const bb1_1 = solvers.solver1.name + " " + solvers.solver1.version + " #BB1"
    const bb1_2 = solvers.solver2.name + " " + solvers.solver2.version + " #BB1"
    const bb2_1 = solvers.solver1.name + " " + solvers.solver1.version + " #BB2"
    const bb2_2 = solvers.solver2.name + " " + solvers.solver2.version + " #BB2"
    const s1 = solvers.solver1.id;
    const s2 = solvers.solver2.id;


    for (let b of benchmarks) {
        if (!isFiltered(filters, b))
            continue
        let tmp2 = b.info_constraints.split("#").map(e => e.split(":")[0])
        for (let i = 1; i < tmp2.length; i++)
            if (!constraints.includes(tmp2[i]))
                constraints.push(tmp2[i])

    }
    constraints.sort()
    for (let f of constraints)
        tmp.push({name: f, [opt1]: 0, [opt2]: 0, [bb1_1]: 0, [bb1_2]: 0, [bb2_1]: 0, [bb2_2]: 0})


    for (let b of benchmarks) {
        if (!isFiltered(filters, b))
            continue
        let tmp2 = b.info_constraints.split("#").map(e => e.split(":")[0])
        let pos = []
        for (let i = 1; i < tmp2.length; i++)
            pos.push(constraints.indexOf(tmp2[i]))

        let d1 = null
        let d2 = null
        for (let d of data[s1])
            if (d.benchmark_id == b.id) {
                d1 = d
                break
            }
        for (let d of data[s2])
            if (d.benchmark_id == b.id) {
                d2 = d
                break
            }
        if (d1 == null || d2 == null)
            continue

        let isopt1 = false
        let isopt2 = false

        if (d1.time !== -1 && d1.time < filters.timeLimit && d1.bug === 0) {
            isopt1 = true
            for (let p of pos)
                tmp[p][opt1]++
        }
        if (d2.time !== -1 && d2.time < filters.timeLimit && d2.bug === 0) {
            isopt2 = true
            for (let p of pos)
                tmp[p][opt2]++
        }

        if (d1.bounds.length === 0 && d2.bounds.length === 0)
            continue

        const b1 = d1.bug === 1 ? false : bestBoundWithTimeLimit(d1.bounds, filters.timeLimit)
        const b2 = d2.bug === 1 ? false : bestBoundWithTimeLimit(d2.bounds, filters.timeLimit)

        let t1 = 0
        let t2 = 0
        if (b1 === false && b2 !== false)
            t2 = 1
        if (b1 !== false && b2 === false)
            t1 = 1

        if (b1 !== false && b2 !== false) {
            if (b1.bound === b2.bound) {
                t1 = 1
                t2 = 1
            } else {
                if (b.type.startsWith("min")) {
                    if (b1.bound < b2.bound)
                        t1 = 1
                    if (b2.bound < b1.bound)
                        t2 = 1

                }
                if (b.type.startsWith("max")) {
                    if (b1.bound > b2.bound)
                        t1 = 1
                    if (b2.bound > b1.bound)
                        t2 = 1
                }
            }
        }

        if (!isopt1 && !isopt2) {
            for (let p of pos)
                tmp[p][bb1_1] += t1
            for (let p of pos)
                tmp[p][bb1_2] += t2
        }

        if (!isopt1 && isopt2)
            for (let p of pos)
                tmp[p][bb2_1] += t1
        if (isopt1 && !isopt2)
            for (let p of pos)
                tmp[p][bb2_2] += t2
    }
    return tmp
}


function createFamiliesData(data, benchmarks, filters, solvers) {


    let tmp = []
    let families = []
    const opt1 = solvers.solver1.name + " " + solvers.solver1.version + " #Opt"
    const opt2 = solvers.solver2.name + " " + solvers.solver2.version + " #Opt"
    const bb1_1 = solvers.solver1.name + " " + solvers.solver1.version + " #BB1"
    const bb1_2 = solvers.solver2.name + " " + solvers.solver2.version + " #BB1"
    const bb2_1 = solvers.solver1.name + " " + solvers.solver1.version + " #BB2"
    const bb2_2 = solvers.solver2.name + " " + solvers.solver2.version + " #BB2"
    const s1 = solvers.solver1.id;
    const s2 = solvers.solver2.id;


    for (let b of benchmarks) {
        if (!isFiltered(filters, b) || families.includes(b.family))
            continue
        families.push(b.family)
    }
    families.sort()
    for (let f of families)
        tmp.push({name: f, [opt1]: 0, [opt2]: 0, [bb1_1]: 0, [bb1_2]: 0, [bb2_1]: 0, [bb2_2]: 0})

    for (let b of benchmarks) {
        if (!isFiltered(filters, b))
            continue
        const pos = families.indexOf(b.family)
        let d1 = null
        let d2 = null
        for (let d of data[s1])
            if (d.benchmark_id === b.id) {
                d1 = d
                break
            }
        for (let d of data[s2])
            if (d.benchmark_id === b.id) {
                d2 = d
                break
            }
        if(d1 == null || d2 == null)
            continue

        let tmp1 = false
        let tmp2 = false
        if (d1.time !== -1 && d1.time < filters.timeLimit && d1.bug === 0) {
            tmp[pos][opt1]++
            tmp1 = true
        }

        if (d2.time !== -1 && d2.time < filters.timeLimit && d2.bug === 0) {
            tmp[pos][opt2]++
            tmp2 = true
        }

        if (d1.bounds.length === 0 && d2.bounds.length === 0)
            continue

        const b1 = d1.bug === 1 ? false : bestBoundWithTimeLimit(d1.bounds, filters.timeLimit)
        const b2 = d2.bug === 1 ? false : bestBoundWithTimeLimit(d2.bounds, filters.timeLimit)



        let t1 = 0
        let t2 = 0
        if (b1 === false && b2 !== false)
            t2 = 1
        if (b1 !== false && b2 === false)
            t1 = 1

        if (b1 !== false && b2 !== false) {
            if (b1.bound === b2.bound) {
                t1 = 1
                t2 = 1
            } else {
                if (b.type.startsWith("min")) {
                    if (b1.bound < b2.bound)
                        t1 = 1
                    if (b2.bound < b1.bound)
                        t2 = 1

                }
                if (b.type.startsWith("max")) {
                    if (b1.bound > b2.bound)
                        t1 = 1
                    if (b2.bound > b1.bound)
                        t2 = 1
                }
            }
        }

        if(!tmp1 && !tmp2) {
            tmp[pos][bb1_1] += t1
            tmp[pos][bb1_2] += t2
        }

        if(!tmp1 && tmp2)
            tmp[pos][bb2_1] += t1
        if(tmp1 && !tmp2)
            tmp[pos][bb2_2] += t2
    }
    return tmp
}

function createCactusDataOptimum(selectedSolvers, data, benchmarks, filters) {
    let tmp = [];
    let data2 = [];
    for (let i = 0; i < selectedSolvers.length; i++)
        if (data[selectedSolvers[i].id] === undefined)
            return []
    let max = -1
    for (let j = 0; j < selectedSolvers.length; j++) {
        let s = selectedSolvers[j];
        let t = data[s.id].filter(e => isFiltered(filters, e) && e.time < filters.timeLimit && e.bug ===0 && e.time >= 0).map(e => e.time)
        if (max < t.length)
            max = t.length
        t.sort((time1, time2) => time1 - time2);
        data2[s.id] = t;
    }

    for (let i = 0; i < max; i++) {
        let current = {"nb": i + 1};
        for (let j = 0; j < selectedSolvers.length; j++) {
            let s = selectedSolvers[j];
            if (data2[s.id][i] !== undefined)
                current[s.name + " " + s.version] = parseInt(data2[s.id][i]);
        }
        tmp.push(current);
    }
    return tmp;
}


function createCactusDataSearch(selectedSolvers, data, benchmarks, filters) {
    let nbBenchmarks = 0
    let tmp = []
    let data2 = []
    let max = -1

    for (let s of selectedSolvers)
        data2[s.id] = []
    for (let i = 0; i < benchmarks.length; i++) {
        let b = benchmarks[i]

        if (isFiltered(filters, b) === false)
            continue
        let unsupported = true
        let [best, optim, unsat] = computeBestBoundWithTimeLimit(b, selectedSolvers, data, filters, i, filters.timeLimit)


         // no bounds known
        if(unsat)
            best = true
        if(best === false)
            continue
        for (let s of selectedSolvers) { // Find best score

            const result = data[s.id][i]
            //if(b.family == "RoadefPlaning2")
            //    console.log(result, is_unsat(result))
            if (result === undefined || result.bug === 1 || result.unsupported === 1)
                continue

            let bound = bestBoundWithTimeLimit(result.bounds, filters.timeLimit)
            if(is_unsat(result))
                data2[s.id].push(result.time)
            else if (bound.bound === best)
                data2[s.id].push(bound.time)

        }
    }

    for (let s of selectedSolvers) {
        if (max < data2[s.id].length)
            max = data2[s.id].length
        data2[s.id].sort((time1, time2) => time1 - time2)
    }

    for (let i = 0; i < max; i++) {
        let current = {"nb": i + 1};
        for (let j = 0; j < selectedSolvers.length; j++) {
            let s = selectedSolvers[j];
            if (data2[s.id][i] !== undefined)
                current[s.name + " " + s.version] = parseInt(data2[s.id][i]);
        }
        tmp.push(current);
    }
    return [tmp, max];
}

function createGraphsData(data, benchmarks, filters, solvers, type) {
    switch (type) {
        case types.scatter:
            return createScatterData(data, benchmarks, filters, solvers)

        case types.families:
            return createFamiliesData(data, benchmarks, filters, solvers)

        case types.constraints:
            return createConstraintsData(data, benchmarks, filters, solvers)
        case types.values:
            return createValuesData(data, benchmarks, filters, solvers)

    }
}

export {createCactusDataOptimum, createCactusDataSearch, createGraphsData}